export default __webpack_public_path__ + "static/mob-astronauts-94ccd807b292009a552e544fc48dfe42.jpg";